import { IRootState } from '../../../store'
import { IInsuranceInformationOptionsState } from '../store/options.types'

export const getInsuranceInformationOptionsSelector = (state: IRootState): IInsuranceInformationOptionsState =>
  state.options.insuranceInformationOptions
